<template>
    <div class="comChart chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType!==null">
                <span class="span_til">展示数据</span>
                <el-input v-model="config.valLength" @change="getRender" type="number"></el-input>
                <div class="unit">条</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType===0">
                <span class="span_til">距离上方</span>
                <el-input v-model="config.grid.top" @change="getRender" type="number"></el-input>
                <div class="unit">%</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType===0">
                <span class="span_til">距离下方</span>
                <el-input v-model="config.grid.bottom" @change="getRender" type="number"></el-input>
                <div class="unit">%</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType===0">
                <span class="span_til">距离左方</span>
                <el-input v-model="config.grid.left" @change="getRender" type="number"></el-input>
                <div class="unit">%</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType===0">
                <span class="span_til">距离右方</span>
                <el-input v-model="config.grid.right" @change="getRender" type="number"></el-input>
                <div class="unit">%</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType===1">
                <span class="span_til">上下位置</span>
                <el-input v-model="config.circle.top" @change="getRender" type="number"></el-input>
                <div class="unit">%</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.gridType===1">
                <span class="span_til">左右位置</span>
                <el-input v-model="config.circle.left" @change="getRender" type="number"></el-input>
                <div class="unit">%</div>
            </div>
            <div class="chartDivConfig selViewConfig colorSel" v-if="config.gridType!==null && config.gridType!==3">
                <span class="span_til">颜色组</span>
                <el-select v-model="config.colorIndex" placeholder="请选择位置"
                           :popper-append-to-body="false" @change="getRender">
                    <el-option
                            :key="index"
                            :label="item.name"
                            :value="index" v-for="(item,index) in colorList">
                        <div class="colorOp">
                            <div class="opColorList">
                                <div>
                                    <div v-for="i in item.color" :style="{backgroundColor:i}"></div>
                                </div>
                            </div>
                            <span>{{item.name}}</span>
                        </div>
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 5:58 下午
     */
    import {colorList} from "../../script/comChart";

    export default {
        name: 'comChart',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {}
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart.comConfig;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.comConfig;
                }
            },
            colorList() {
                let list = [];
                for (let i in colorList) {
                    list.push({
                        name: i,
                        color: colorList[i]
                    });
                }
                return list;
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .comChart {
        .colorSel {
            .el-select-dropdown {
                .colorOp {
                    width: 100%;
                    height: 100%;
                    display: inline-block;

                    span {
                        width: 50%;
                        height: 100%;
                        display: inline-block;
                        float: left;
                        padding-left: 5px;
                        text-align: center;
                        .text_oneLine;
                    }


                    .opColorList {
                        width: 50%;
                        height: 100%;
                        max-width: 60px;
                        float: left;
                        display: inline-block;

                        > div {
                            width: 100%;
                            height: 60%;
                            display: inline-block;
                            .com_middle;

                            > div {
                                width: calc(100% / 6);
                                height: 50%;;
                                position: relative;
                                float: left;
                                display: inline-block;
                            }

                            > div {
                                width: calc(100% / 6);
                                height: 50%;
                                float: left;
                                display: inline-block;
                            }
                        }
                    }
                }
            }
        }

    }
</style>